import type { ComponentProps, PropsWithChildren } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const iconWrapperVariants = tv({
  base: "flex flex-row items-center justify-center",
  variants: {
    size: {
      sm: "size-5",
      md: "size-6",
      lg: "size-6",
      xl: "size-10",
      tight: "",
    },
  },
});

type IconWrapperProps = VariantProps<typeof iconWrapperVariants> &
  Pick<ComponentProps<"div">, "style" | "className">;

export const IconWrapper = ({
  children,
  className,
  size = "md",
  style,
}: PropsWithChildren<IconWrapperProps>) => {
  return (
    <div className={iconWrapperVariants({ size, className })} style={style}>
      {children}
    </div>
  );
};
